/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSwatchSelector_item = {
    readonly " $fragmentRefs": FragmentRefs<"SwatchSelector_item">;
    readonly " $refType": "PdpRespSwatchSelector_item";
};
export type PdpRespSwatchSelector_item$data = PdpRespSwatchSelector_item;
export type PdpRespSwatchSelector_item$key = {
    readonly " $data"?: PdpRespSwatchSelector_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSwatchSelector_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSwatchSelector_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SwatchSelector_item",
      "args": [
        {
          "kind": "Literal",
          "name": "shouldFetchBuyerInfo",
          "value": true
        }
      ]
    }
  ]
};
(node as any).hash = '376b451a90f2ab28f5b94e7af2f4f6bd';
export default node;
